import { render, staticRenderFns } from "./IdleView.vue?vue&type=template&id=6cc74e02&scoped=true&"
import script from "./IdleView.vue?vue&type=script&lang=js&"
export * from "./IdleView.vue?vue&type=script&lang=js&"
import style0 from "./IdleView.vue?vue&type=style&index=0&id=6cc74e02&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc74e02",
  null
  
)

export default component.exports